export enum NotificationTypes {
  PRODUCT_UPDATE = 'PRODUCT_UPDATE',
  USER_NOTIFICATION = 'USER_NOTIFICATION'
}

export enum TargetTypes {
  USER = 'USER',
  TEAM = 'TEAM',
  GLOBAL = 'GLOBAL'
}

export type NotificationType = `${NotificationTypes}`;
export type TargetType = `${TargetTypes}`;

export type TypeRecord<T extends string> = Record<T, { value: T; label: string }>;

export const NotificationTypeRecord: TypeRecord<NotificationType> = {
  [NotificationTypes.PRODUCT_UPDATE]: {
    value: NotificationTypes.PRODUCT_UPDATE,
    label: 'Product Update'
  },
  [NotificationTypes.USER_NOTIFICATION]: {
    value: NotificationTypes.USER_NOTIFICATION,
    label: 'User Notification'
  }
};

export const TargetTypeRecord: TypeRecord<TargetType> = {
  [TargetTypes.USER]: { value: TargetTypes.USER, label: 'User' },
  [TargetTypes.TEAM]: { value: TargetTypes.TEAM, label: 'Team' },
  [TargetTypes.GLOBAL]: { value: TargetTypes.GLOBAL, label: 'Global' }
};

export interface Notification {
  id: string;
  created_at: string;
  updated_at: string;
  notification_type: NotificationType;
  target_type: TargetType;
  target_user_id: string | null;
  target_team_id: string | null;
  title: string;
  message: string;
  metadata_json: string | null;
  expires_at: string | null;
  deleted_at: string | null;
  read_at?: string | null;
}
